import ScalarIconX_vue_vue_type_script_setup_true_lang_default from "./ScalarIconX.vue_vue_type_script_setup_true_lang.js";
//#region src/components/ScalarIconX.vue
var ScalarIconX_default = ScalarIconX_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarIconX_default as default };

//# sourceMappingURL=ScalarIconX.js.map